import { useEffect } from 'react';
import { useGamificationSettings } from './useGamificationSettings';

/**
 * Hook to manage high contrast mode across the application.
 * When enabled, adds a CSS class to the document root that enhances visibility.
 */
export const useHighContrastMode = () => {
  const { settings } = useGamificationSettings();
  
  useEffect(() => {
    if (settings.highContrastMode) {
      document.documentElement.classList.add('high-contrast');
    } else {
      document.documentElement.classList.remove('high-contrast');
    }
  }, [settings.highContrastMode]);
  
  return settings.highContrastMode;
};
